import { pushEvent, pushData } from '../../utils/datalayer';
import { intersectionViewportObserver, debounce } from 'Utils/';

const UAEVENT = 'uaevent';
const NIEVENT = 'nievent';
const NAV_ITEM_EVENT_CATEGORY = 'main menu navigation';
let initialProductData = [];
export const tagging = {
  name: 'vch-tagging',
  inserted: (el, binding) => {
    const { arg } = binding;

    if (arg === 'navclick') {
      el.addEventListener('click', () => {
        const mql = window.matchMedia('(max-width: 1024px)');
        // Mobile - Only clicks, no hover
        if (mql.matches) {
          pushEvent({
            event: UAEVENT,
            eventCategory: NAV_ITEM_EVENT_CATEGORY,
            eventAction: 'select::burger menu',
            eventLabel: binding.value.label,
            event_name: 'menu_click',
            click_area: 'burger menu',
            breadcrumb: binding.value.label,
          });
        }
        // Desktop
        else {
          pushEvent({
            event: UAEVENT,
            eventCategory: NAV_ITEM_EVENT_CATEGORY,
            eventAction: 'select::header',
            eventLabel: binding.value.label,
            event_name: 'menu_click',
            click_area: 'header',
            breadcrumb: binding.value.label,
          });
        }
      });
    }

    if (arg === 'navsearch') {
      el.addEventListener('submit', () => {
        const searchQuery = el.querySelector('input[name="query"]')?.value;
        pushEvent({
          event: UAEVENT,
          eventCategory: 'internal search',
          eventAction: 'search::manual',
          eventLabel: searchQuery,
        });
      });
    }

    // Accordinon Open Tagging
    // Checks isClosing from the details accordion directive
    if (arg === 'detailopen') {
      const data = binding.value.data;
      const eventData = typeof data === 'string' ? JSON.parse(data) : data;
      const onToggle = () => {
        if (!el.open || el?.isClosing) return;
        pushEvent(eventData);
      };
      el.querySelector('summary').addEventListener('click', onToggle);
    }

    if (
      binding.value &&
      (arg === 'productclick' || arg === 'productimpression')
    ) {
      const data = binding.value.data;
      const editData = typeof data === 'string' ? JSON.parse(data) : data;
      const onEvent = function (event) {
        if (event.type === 'click' && arg === 'productclick') {
          pushEvent(editData);
        }
      };
      el.addEventListener('click', onEvent);
      // product impression
      const onImpression = function () {
        if (arg === 'productimpression') {
          initialProductData.push(editData);
          setTimeout(function () {
            if (initialProductData.length > 0) {
              let processedProductData = initialProductData.reduce(function (
                s,
                a
              ) {
                s = [...s, ...a.ecommerce.impressions];
                return s;
              },
              []);
              let processedDataLayerImpression = initialProductData[0];
              processedDataLayerImpression.ecommerce.impressions =
                processedProductData;
              pushEvent(processedDataLayerImpression);
              initialProductData = [];
            }
          }, 700);
        }
      };
      intersectionViewportObserver(el, { checkIsVisible: true }).then(
        onImpression
      );
    }

    if (arg === 'pagedata') {
      const data = binding.value.data;
      const sendData = typeof data === 'string' ? JSON.parse(data) : data;
      setTimeout(() => {
        pushData(sendData);        
      }, 3000);
    }

    if (arg === 'buyclick') {
      const data = binding.value.data;
      const sendData = typeof data === 'string' ? JSON.parse(data) : data;
      const onEvent = function () {
        pushData(sendData);
      };
      el.addEventListener('click', onEvent);
    }

    if (arg === 'articleread') {
      let timerReached = false;
      let thresholdReached = false;
      let scrollHandler;

      const sendEvent = () => {
        if (timerReached && thresholdReached) {
        let articleClass = document.getElementsByClassName("heading-xl uppercase mb-lg");
        let articleName;
        if (articleClass.length > 0) {
          articleName = articleClass[0].innerText.toLowerCase();
        }
          pushEvent({
            event: UAEVENT,
            eventCategory: 'content page::article',
            eventAction: 'read article',
            eventLabel: articleName,
            event_name: 'read_article',
            article_name: articleName,
          });
        }
      };

      const onScroll = () => {
        // Checks scroll offet - *from the bottom of the window*
        // to see if enough of the document has become visible
        if (
          window.pageYOffset + document.body.offsetHeight >=
          document.documentElement.scrollHeight * 0.75
        ) {
          thresholdReached = true;
          sendEvent();
          window.removeEventListener('scroll', scrollHandler);
        }
      };

      scrollHandler = debounce(onScroll, 50);
      window.addEventListener('scroll', scrollHandler);

      setTimeout(() => {
        timerReached = true;
        sendEvent();
      }, 30000);
    }

    if (arg === 'onvisible') {
      const data = binding.value.data;
      const editData = typeof data === 'string' ? JSON.parse(data) : data;
      intersectionViewportObserver(el, { checkIsVisible: true }).then(() =>
        pushEvent(editData)
      );
    }
  },
};
